import { render, staticRenderFns } from "./Kostenersatz.vue?vue&type=template&id=e9250034&scoped=true"
import script from "./Kostenersatz.vue?vue&type=script&lang=ts"
export * from "./Kostenersatz.vue?vue&type=script&lang=ts"
import style0 from "./Kostenersatz.vue?vue&type=style&index=0&id=e9250034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9250034",
  null
  
)

export default component.exports